import IngredientItem from './IngredientsItems/IngredientItem'
import IngredientsWrapper from './IngredientsItems/IngredientsWrapper'
import RecipeInfoItem from './RecipeInfo/RecipeInfoItem'
import RecipeInfoWrapper from './RecipeInfo/RecipeInfoWrapper'

const exports = {
  RecipeInfoWrapper,
  RecipeInfoItem,
  IngredientItem,
  IngredientsWrapper,
}

export default exports
